module.exports = __webpack_public_path__ + "img/builder-bg.0408fbba.png";